import { UploadException } from './upload.exception';

export class InvalidSizeException extends UploadException {
  public constructor(message = 'Invalid file size exception.') {
    super(message);
  }
}
